import { render, staticRenderFns } from "./campaingContent.vue?vue&type=template&id=0b4d7227"
import script from "./campaingContent.vue?vue&type=script&lang=js"
export * from "./campaingContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports